module.exports = dicomParser;